// src/components/ProtectedRoute.js

import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { GlobalContext } from '../contexts/GlobalContext';

function ProtectedRoute({ children, requiredLevel }) {
    const { isLoggedIn, userLevel, setIsLoggedIn, setUserLevel } = useContext(GlobalContext);
    const [authChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/check`, {
                    credentials: 'include',
                });
                if (response.ok) {
                    const data = await response.json();
                    console.log('isAuthenticated? ',data);
                    setIsLoggedIn(true);
                    // setUserLevel(data.userLevel);
                } else {
                    setIsLoggedIn(false);
                    setUserLevel(null);
                }
            } catch (error) {
                console.error('Error checking auth:', error);
                setIsLoggedIn(false);
                setUserLevel(null);
            } finally {
                setAuthChecked(true);
            }
        };

        checkAuth();
    }, [setIsLoggedIn, setUserLevel]);

    if (!authChecked) {
        return <p>驗證中...</p>;
    }

    if (!isLoggedIn || userLevel != requiredLevel) {
        console.log(`isLoggedIn: ${isLoggedIn}, userLevel: ${userLevel}`);
        return <Navigate to="/login" />;
    }

    return children;
}

export default ProtectedRoute;
